import { AveControlMessageType } from '../webrtc/ave-data-channel.js';
export function buildMouseDownInteraction(videoElement, mouseEvent) {
    const coord = normalizeAndQuantizeUnsigned(videoElement, mouseEvent);
    return {
        id: AveControlMessageType.MouseDown,
        data: [
            { payload: mouseEvent.button, type: 'uint8' },
            { payload: coord.x, type: 'uint16' },
            { payload: coord.y, type: 'uint16' }
        ]
    };
}
export function buildMouseUpInteraction(videoElement, mouseEvent) {
    const coord = normalizeAndQuantizeUnsigned(videoElement, mouseEvent);
    return {
        id: AveControlMessageType.MouseUp,
        data: [
            { payload: mouseEvent.button, type: 'uint8' },
            { payload: coord.x, type: 'uint16' },
            { payload: coord.y, type: 'uint16' }
        ]
    };
}
export function buildMouseMoveInteraction(videoElement, mouseEvent) {
    const coord = normalizeAndQuantizeUnsigned(videoElement, mouseEvent);
    const delta = normalizeAndQuantizeSigned(videoElement, mouseEvent);
    return {
        id: AveControlMessageType.MouseMove,
        data: [
            { payload: coord.x, type: 'uint16' },
            { payload: coord.y, type: 'uint16' },
            { payload: delta.x, type: 'int16' },
            { payload: delta.y, type: 'int16' }
        ]
    };
}
export function buildMouseWheelInteraction(videoElement, wheelEvent) {
    const coord = normalizeAndQuantizeUnsigned(videoElement, wheelEvent);
    return {
        id: AveControlMessageType.MouseWheel,
        data: [
            // "Epic" uses WheelEvent.wheelDelta which is marked deprecated.
            // Instead, we use WheelEvent.deltaY which has the inverse sign, so we need to use an extra minus.
            { payload: -wheelEvent.deltaY, type: 'int16' },
            { payload: coord.x, type: 'uint16' },
            { payload: coord.y, type: 'uint16' }
        ]
    };
}
function normalizeAndQuantizeUnsigned(videoElement, positionEvent) {
    const videoElementBoundingClientRect = videoElement.getBoundingClientRect();
    const offsetX = positionEvent.clientX - videoElementBoundingClientRect.left;
    const offsetY = positionEvent.clientY - videoElementBoundingClientRect.top;
    const normalizedX = offsetX / videoElementBoundingClientRect.width;
    const normalizedY = offsetY / videoElementBoundingClientRect.height;
    if (normalizedX < 0.0 || normalizedX > 1.0 || normalizedY < 0.0 || normalizedY > 1.0) {
        // Event is out of bounds.
        return {
            x: 65535,
            y: 65535
        };
    }
    return {
        x: normalizedX * 65536,
        y: normalizedY * 65536
    };
}
function normalizeAndQuantizeSigned(videoElement, moveEvent) {
    const normalizedX = moveEvent.movementX / (0.5 * videoElement.clientWidth);
    const normalizedY = moveEvent.movementY / (0.5 * videoElement.clientHeight);
    return {
        x: normalizedX * 32767,
        y: normalizedY * 32767
    };
}
//# sourceMappingURL=user-interaction-builder.js.map